module.exports = __webpack_public_path__ + "media/application/images/perish/title-750-2b2c7ee26f753351ecf789239220ca00.png";